import React from "react";
import { Home, X, Download, Printer } from "lucide-react";
import { Button } from "@/components/ui/button";

interface PdfViewerProps {
    fileUrl: string;
    fileName: string;
    onClose: () => void;
}

export const PdfViewer = ({ fileUrl, fileName, onClose }: PdfViewerProps) => {
    return (
        <div className="flex flex-col h-full bg-[#f3f4f6]">
            {/* Top Navigation Bar */}
            <div className="h-10 bg-white border-b flex items-center px-4 text-xs text-blue-600">
                <Button variant="ghost" size="sm" className="h-6 w-6 p-0 mr-2" onClick={onClose}>
                    <Home className="h-4 w-4 text-gray-400" />
                </Button>
                <span className="text-gray-400 mx-2">/</span>
                <span className="cursor-pointer hover:underline" onClick={onClose}>Archivos</span>
                <span className="text-gray-400 mx-2">/</span>
                <span className="font-semibold text-gray-700">{fileName}</span>
                <div className="flex-1"></div>
                <Button variant="ghost" size="sm" className="h-7 w-7 p-0 ml-2" onClick={onClose}>
                    <X className="h-4 w-4 text-gray-400" />
                </Button>
            </div>

            {/* PDF Viewer Container */}
            <div className="flex-1 bg-gray-800 p-0 sm:p-4 flex justify-center">
                <iframe 
                    src={`${fileUrl}#toolbar=1`} 
                    className="w-full max-w-5xl h-full shadow-2xl bg-white sm:rounded-lg border-none"
                    title={fileName}
                />
            </div>
        </div>
    );
};
